var h = Object.defineProperty;
var o = (a, i, t) => i in a ? h(a, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[i] = t;
var s = (a, i, t) => (o(a, typeof i != "symbol" ? i + "" : i, t), t);
class c {
  transformOptions(i) {
    return process.env.LEAD_GENERATOR_APPLICATION_ID && (i.headers.ConsumerApplication = process.env.LEAD_GENERATOR_APPLICATION_ID), process.env.GATSBY_LEAD_GENERATOR_APPLICATION_ID && (i.headers.ConsumerApplication = process.env.GATSBY_LEAD_GENERATOR_APPLICATION_ID), process.env.GATSBY_COMMUNICATION_KEY && (i.headers["communication-key"] = process.env.GATSBY_COMMUNICATION_KEY), Promise.resolve(i);
  }
}
class v extends c {
  constructor(t, r) {
    super();
    s(this, "http");
    s(this, "baseUrl");
    s(this, "jsonParseReviver");
    this.http = r || window, this.baseUrl = t ?? "";
  }
  /**
   * Get all cities
   * @param filter (optional) Only cities that contain this filter in their name or start with this in the postalcode will be returned
   * @return Payload of Array of CityMultiLingualDTO
   */
  getAllCities(t) {
    let r = this.baseUrl + "/cities?";
    t != null && (r += "filter=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
    let n = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(n).then((e) => this.http.fetch(r, e)).then((e) => this.processGetAllCities(e));
  }
  processGetAllCities(t) {
    const r = t.status;
    let n = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, l) => n[l] = e), r === 200 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), l;
    }) : r === 500 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 502 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 503 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 504 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, n)) : Promise.resolve(null);
  }
  /**
   * Get Street
   * @param cityId Format: 3 or 4 digits
   * @param streetName (optional) Format: At least 3 characters
   * @return Payload of Array of CityWithStreetsDTO
   */
  getStreet(t, r) {
    let n = this.baseUrl + "/cities/{cityId}/streets?";
    if (t == null)
      throw new Error("The parameter 'cityId' must be defined.");
    n = n.replace("{cityId}", encodeURIComponent("" + t)), r != null && (n += "streetName=" + encodeURIComponent("" + r) + "&"), n = n.replace(/[?&]$/, "");
    let e = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((l) => this.http.fetch(n, l)).then((l) => this.processGetStreet(l));
  }
  processGetStreet(t) {
    const r = t.status;
    let n = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, l) => n[l] = e), r === 200 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), l;
    }) : r === 500 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 502 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 503 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 504 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, n)) : Promise.resolve(null);
  }
  /**
   * Get countries
   * @param language Language (nl/fr)
   * @return Payload of Array of CodeValuePair
   */
  getCountries(t) {
    let r = this.baseUrl + "/countries?";
    if (t == null)
      throw new Error("The parameter 'language' must be defined and cannot be null.");
    r += "language=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
    let n = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(n).then((e) => this.http.fetch(r, e)).then((e) => this.processGetCountries(e));
  }
  processGetCountries(t) {
    const r = t.status;
    let n = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, l) => n[l] = e), r === 200 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), l;
    }) : r === 500 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 502 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 503 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 504 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, n)) : Promise.resolve(null);
  }
  /**
   * Get health
   * @return Payload of HealthDTO
   */
  getHealth() {
    let t = this.baseUrl + "/health";
    t = t.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(r).then((n) => this.http.fetch(t, n)).then((n) => this.processGetHealth(n));
  }
  processGetHealth(t) {
    const r = t.status;
    let n = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, l) => n[l] = e), r === 200 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), l;
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, n)) : Promise.resolve(null);
  }
  /**
   * Get nationalities
   * @param language Language (nl/fr)
   * @return Payload of Array of CodeValuePair
   */
  getNationalities(t) {
    let r = this.baseUrl + "/nationalities?";
    if (t == null)
      throw new Error("The parameter 'language' must be defined and cannot be null.");
    r += "language=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
    let n = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(n).then((e) => this.http.fetch(r, e)).then((e) => this.processGetNationalities(e));
  }
  processGetNationalities(t) {
    const r = t.status;
    let n = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, l) => n[l] = e), r === 200 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), l;
    }) : r === 500 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 502 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 503 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 504 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, n)) : Promise.resolve(null);
  }
  /**
   * Get risk
   * @param streetId (optional) Format: up to 6 digits
   * @param houseNumber (optional) The housenumber
   * @return Payload of RiskDTO
   */
  getRisk(t, r) {
    let n = this.baseUrl + "/risk-scorings?";
    t != null && (n += "streetId=" + encodeURIComponent("" + t) + "&"), r != null && (n += "houseNumber=" + encodeURIComponent("" + r) + "&"), n = n.replace(/[?&]$/, "");
    let e = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((l) => this.http.fetch(n, l)).then((l) => this.processGetRisk(l));
  }
  processGetRisk(t) {
    const r = t.status;
    let n = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, l) => n[l] = e), r === 200 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), l;
    }) : r === 500 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 502 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 503 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r === 504 ? t.text().then((e) => {
      let l = null;
      return l = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDTO", r, e, n, l);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, n)) : Promise.resolve(null);
  }
}
class d extends Error {
  constructor(t, r, n, e, l) {
    super();
    s(this, "message");
    s(this, "status");
    s(this, "response");
    s(this, "headers");
    s(this, "result");
    s(this, "isApiException", !0);
    this.message = t, this.status = r, this.response = n, this.headers = e, this.result = l;
  }
  static isApiException(t) {
    return t.isApiException === !0;
  }
}
function u(a, i, t, r, n) {
  throw n ?? new d(a, i, t, r, null);
}
export {
  v as AddressApiClient,
  c as AddressApiClientBase,
  d as ApiException
};
